export default "__VITE_PUBLIC_ASSET__3f6773a0__"